// React import not required with automatic JSX runtime

interface FormSelectProps<T extends string> {
  label: string;
  value: T;
  onChange: (value: T) => void;
  options: { value: T; label: string }[];
  placeholder?: string;
  hideLabel?: boolean;
}

export const FormSelect = <T extends string>({
  label,
  value,
  onChange,
  options,
  placeholder,
  hideLabel = false,
}: FormSelectProps<T>) => {
  return (
    <div>
      <label
        className={
          hideLabel ? 'sr-only' : 'block text-sm font-medium text-slate-700 dark:text-slate-200'
        }
      >
        {label}
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
        className="mt-1 block w-full rounded-md border border-slate-200 bg-white px-3 py-2 shadow-sm transition duration-150 ease-in-out hover:border-slate-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 dark:border-surface-600 dark:bg-surface-800 dark:text-white dark:hover:border-surface-500 sm:text-sm"
        aria-label={hideLabel ? label : undefined}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
